<template>
  <div>
    <hg-dialog title="资源库" :width="800" :height="400" :visible="show" @close="handleClose">
      <search
        @getResourceList="getResourceData"
      ></search>
      <list :dataList.sync="resourceList" :functionType="functionType"/>
      <span slot="footer" class="hg-dialog-footer">
        <el-button type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
  import search from './search';
  import list from './list';
  import HgDialog from '@/components/dialog';

  export default {
    name: 'resource',
    components: {
      search,
      list,
      HgDialog
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      resourceList: {
        type: Array
      },
      functionType: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        dialogVisible: false
      };
    },
    computed: {
      selected() {
        let ids = [];
        this.resourceList.forEach(data => {
          if (data.checked) {
            ids.push(data.id);
          }
        });
        return {
          ids
        };
      }
    },
    methods: {
      submit() {
        this.updateResource();
      },
      async updateResource() {
        const res = await this.$services.postJson({
          type: 'RESOURCEMANGEMENT',
          url: 'updateResource',
          params: {
            ids: this.selected.ids.join(','),
            checked: '1'
          }
        });
        if (res.code === '000') {
          this.$toaster.ok('保存成功');
          this.handleClose();
          this.$emit('refresh');
        }
        else {
          this.$toaster.error(res.msg);
        }
      },
      getResourceData(params) {
        this.$emit('getResourceData', params);
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit('close');
      }
    },
    watch: {
      show(val) {
        if (val) {
          this.dialogVisible = true;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .dailgo-content {
    flex-direction: column;
  }

  .el-table .el-table__body-wrapper {
    height: auto;
  }
</style>
